import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { ButtonIcon, ButtonSize, ButtonVariant, Typography } from '@shipengine/giger';
import { getDropOffAddressInfoStyles, getDropOffAddressInfoCloseStyles, getDropOffAddressInfoNameStyles, getDropOffAddressInfoTextStyles, getDropOffAddressInfoOpeningDayStyles, getDropOffAddressInfoOpeningHourStyles } from './DropOffAddressInfoStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const DropOffAddressInfo = _ref => {
  let {
    selected,
    allowClose,
    theme,
    onDropOffPointClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    businessName,
    openingTimes,
    address,
    zip,
    city,
    id
  } = selected;
  return jsxs("div", {
    css: getDropOffAddressInfoStyles(theme),
    children: [allowClose && jsx(ButtonIcon, {
      icon: IconNames.CLOSE,
      size: ButtonSize.SMALL,
      variant: ButtonVariant.TEXT,
      onClick: onDropOffPointClose,
      css: getDropOffAddressInfoCloseStyles(theme),
      ariaDescribedby: 'dropoff-address-close',
      children: t('drop-off.address-action.close')
    }), jsx(Typography, {
      css: getDropOffAddressInfoNameStyles(theme),
      variant: "heading6",
      children: businessName
    }), jsx(Typography, {
      css: getDropOffAddressInfoTextStyles(theme),
      component: "p",
      variant: "body2",
      children: `${address}, ${zip} - ${city}`
    }), openingTimes.map(_ref2 => {
      let {
        day,
        time
      } = _ref2;
      return jsxs("div", {
        children: [jsx(Typography, {
          css: getDropOffAddressInfoOpeningDayStyles(theme),
          variant: "small",
          children: jsxs("span", {
            children: [t(day), ":"]
          })
        }), jsx(Typography, {
          css: getDropOffAddressInfoOpeningHourStyles,
          variant: "small",
          component: "p",
          children: time || t('drop-off.address-state.closed')
        })]
      }, `${id}-${day}-${time || ''}`);
    })]
  });
};

export { DropOffAddressInfo };
//# sourceMappingURL=DropOffAddressInfo.js.map
